var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
const computeFlexWeight = /* @__PURE__ */ __name((grow) => {
  if (typeof grow === "number") {
    return grow;
  }
  return grow ? 1 : 0;
}, "computeFlexWeight");

export { computeFlexWeight };
//# sourceMappingURL=compute.js.map
